import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { TransitRequestDto } from './transit-request.model';
import { TransitAdminDto } from 'src/app/admin/e-services/e-booking/shared/models/transit-admin.model';


@Injectable({ providedIn: 'root' })
export class TransitService {

  constructor(private http: HttpServices) {
  }


  add(transitRequest: TransitRequestDto) {
    return this.http.post('Transit/Add', transitRequest);
  }
  Update(transitRequest: TransitRequestDto) {
    return this.http.post('Transit/Update', transitRequest);
  }

  get(id: string) {
    return this.http.get('Transit/Get/' + id);
  }
  CancelTransit(data:TransitAdminDto) {
    return this.http.post('Transit/CancelTransit', data);
  }

  CheckDuplicateIMONumber(IMONumber: string) {
    return this.http.get('Transit/CheckDuplicateIMONumber?IMONumber=' + IMONumber);
  }
}